"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _static = require("../static");
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
var _changePhone = _interopRequireDefault(require("./changePhone.vue"));
var customerOrderApi = _interopRequireWildcard(require("@/api/customerOrderApi.js"));
var _transformState = _interopRequireDefault(require("@/utils/transformState.js"));
var _selectCompay = _interopRequireDefault(require("../../../business/supplier/coupons/selectCompay.vue"));
var _cardDetailApi = require("@/api/cardDetailApi");
var _index = _interopRequireDefault(require("@/components/QrcodeGenerator/index.vue"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    SelectCompay: _selectCompay.default,
    ChangePhone: _changePhone.default,
    QrcodeGenerator: _index.default
  },
  data: function data() {
    return {
      customerOrderOptions: _static.customerOrderOptions,
      visibleDrawer: false,
      //是否为展开
      orderCardOption: _static.orderCardOption,
      constants: this.$constants,
      listPram: {
        keywords: null,
        cid: null,
        page: 1,
        limit: this.$constants.page.limit[0],
        orderName: null,
        secretKey: null,
        customerId: null
      },
      listData: {
        list: [],
        total: 0
      },
      usedCardNoRange: [],
      listLoading: true,
      orderId: null,
      appOptions: [],
      // 小程序选项
      customerOptions: [] // 归属客户选项
    };
  },
  created: function created() {
    this.getAppList();
    // We'll get customer list from the main API response if available
    // Only call it separately if needed
  },
  mounted: function mounted() {},
  methods: {
    throttle: _throttle.default,
    transformState: _transformState.default,
    initOpen: function initOpen(orderId) {
      this.orderId = orderId;
      this.visibleDrawer = true;
      this.usedCardNoRange = [];

      // Reset all filters when opening
      this.listPram = {
        page: 1,
        limit: this.$constants.page.limit[0],
        orderName: null,
        secretKey: null,
        customerId: null,
        kamiId: null,
        phone: null,
        status: null
      };

      // If we don't have customer options yet, fetch them
      if (!this.customerOptions || this.customerOptions.length === 0) {
        this.getCustomerList();
      }
      this.handlerGetListData(this.listPram);
    },
    handerSearch: function handerSearch() {
      var _this = this;
      var doRefresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (doRefresh == 1) {
        this.listPram = {
          page: 1,
          limit: this.$constants.page.limit[0],
          orderName: null,
          secretKey: null,
          customerId: null,
          kamiId: null,
          phone: null,
          status: null
        };
      }
      ;

      // Always reset to page 1 when searching
      this.listPram.page = 1;

      // Remove any null, undefined or empty string values from the params
      var cleanParams = {};
      Object.keys(this.listPram).forEach(function (key) {
        if (_this.listPram[key] !== null && _this.listPram[key] !== undefined && _this.listPram[key] !== '') {
          cleanParams[key] = _this.listPram[key];
        }
      });
      this.handlerGetListData(_objectSpread(_objectSpread({}, cleanParams), {}, {
        page: 1,
        limit: this.listPram.limit
      }));
    },
    handlerGetListData: function handlerGetListData() {
      var _this2 = this;
      var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.listLoading = true;
      console.log('Request params:', _objectSpread(_objectSpread({}, pram), {}, {
        cusOrderId: this.orderId
      }));
      customerOrderApi.camiListArticle(_objectSpread(_objectSpread({}, pram), {}, {
        cusOrderId: this.orderId
      })).then(function (response) {
        console.log('API response:', response);
        // The interceptor has already extracted data from response.data
        // So response is directly the content of the data field

        if (response && response.page && response.page.list) {
          // Handle the new response format where we get page directly
          _this2.listData = {
            list: response.page.list || [],
            total: response.page.total || 0
          };
          _this2.usedCardNoRange = Array.isArray(response.usedCardNoRange) ? response.usedCardNoRange : [];

          // Update customer options if available in the response
          if (response.customerList && response.customerList.length > 0) {
            _this2.customerOptions = response.customerList;
          }
          console.log('Processed data:', _this2.listData);
        } else {
          // If data doesn't have expected structure, set empty list
          _this2.listData = {
            list: [],
            total: 0
          };
          _this2.usedCardNoRange = [];
          console.error('Invalid data structure received:', response);
        }
        _this2.listLoading = false;
      }).catch(function (err) {
        _this2.listLoading = false;
        _this2.usedCardNoRange = [];
        console.error('Error fetching data:', err);
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData(this.listPram);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData(this.listPram);
    },
    selectCompany: function selectCompany(companyId) {
      this.$set(this.listPram, 'companyId', companyId);
      this.handerSearch();
    },
    // 删除订单
    handlerDelete: function handlerDelete(id) {
      var _this3 = this;
      this.$confirm('确定作废当前数据', '提示').then(function (result) {
        customerOrderApi.removeKami(id).then(function (data) {
          _this3.$message.success('卡密已作废！');
          _this3.handlerGetListData(_this3.listPram);
        }).then(function (err) {
          _this3.listLoading = false;
        });
      });
    },
    // 卡密短信发送
    sendMessage: function sendMessage(id) {
      var _this4 = this;
      this.$confirm('是否确认发送短信', '提示').then(function (result) {
        _this4.listLoading = true;
        _this4.$message.warning('短信发送中，请等待');
        customerOrderApi.sendMessage(id).then(function (res) {
          _this4.listLoading = false;
          _this4.$message.success('发送成功！');
        }).then(function (err) {
          _this4.listLoading = false;
        });
      });
    },
    // 修改用户手机号
    changeUserPhone: function changeUserPhone(row) {
      this.$refs['ChangePhoneRef'].initOpen(row);
    },
    // 重新生成卡密二维码
    refreshQrcode: function refreshQrcode() {
      var _this5 = this;
      customerOrderApi.refreshKamiQrcode(this.orderId).then(function (res) {
        _this5.handerSearch(1);
        _this5.$message.success('操作成功！');
      });
    },
    // 获取小程序列表
    getAppList: function () {
      var _getAppList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return (0, _cardDetailApi.getMiniappList)();
            case 1:
              res = _context.v;
              if (res && Array.isArray(res)) {
                this.appOptions = res.map(function (item) {
                  return {
                    id: item.id,
                    name: item.appName
                  };
                });
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              this.$message.error('获取小程序列表失败');
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getAppList() {
        return _getAppList.apply(this, arguments);
      }
      return getAppList;
    }(),
    // 重置所有筛选条件
    resetFilters: function resetFilters() {
      this.listPram = {
        page: 1,
        limit: this.$constants.page.limit[0],
        orderName: null,
        secretKey: null,
        customerId: null,
        kamiId: null,
        phone: null,
        status: null
      };
      this.handlerGetListData(this.listPram);
      this.$message.success('筛选条件已重置');
    },
    // 获取归属客户列表
    getCustomerList: function () {
      var _getCustomerList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var response, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return customerOrderApi.getAllCustomer();
            case 1:
              response = _context2.v;
              console.log('Customer API response:', response);

              // The interceptor has already extracted data from response.data
              // So we're directly working with the content of the data field
              if (response && Array.isArray(response)) {
                // Direct array of customers
                this.customerOptions = response;
              } else if (response && response.customerList && Array.isArray(response.customerList)) {
                // Customer list inside response
                this.customerOptions = response.customerList;
              }
              console.log('Customer options:', this.customerOptions);
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.error('Error fetching customer list:', _t2);
              this.$message.error('获取归属客户列表失败');
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function getCustomerList() {
        return _getCustomerList.apply(this, arguments);
      }
      return getCustomerList;
    }()
  }
};